module.exports = __webpack_public_path__ + "static/media/temp_30.24a18afd.jpg";